// extracted by mini-css-extract-plugin
export var column = "grid-module--column--hBgRe";
export var grid = "grid-module--grid--oO3M+";
export var gridMobile = "grid-module--grid-mobile--oJNYb";
export var item = "grid-module--item--55yWB";
export var itemContent = "grid-module--item-content--EVQWP";
export var itemImage = "grid-module--item-image--GvE1m";